import s from './breadcrumb.module.css';
import { getRedirectUrlPath } from '../../actions/page';
import { store } from '../../store';
import { retailerSettingsService } from './../../services';

class BreadcrumbController {
  constructor($location) {
    const {
      page: { bypassSteps = [] },
    } = store.getState();
    this.isSimpleReturnsBasic = retailerSettingsService.getIsSimpleReturnsBasic();
    this.s = s;
    this.disabledStep2 = bypassSteps.includes('methods');
    this.stepRedirect = (step, event) => {
      event.preventDefault();
      if (step && this.step > step) {
        $location.path(store.dispatch(getRedirectUrlPath(`step-${step}`)));
      }
    };
  }
}

BreadcrumbController.$inject = ['$location'];

export default BreadcrumbController;
